import { styled } from '@mui/system';
import { Button } from '@mui/material';
import { fontFamilies, colors } from '../../constants/theme';

export const CTAButtonContained = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'additionalStyles',
})(({ theme, additionalStyles }) => ({
  padding: '10px 50px',
  borderRadius: '10px',
  backgroundColor: '#29405A',
  boxShadow: 'none',
  fontSize: '20px',
  fontWeight: 500,
  fontFamily: fontFamilies.quicksand,
  letterSpacing: 0,
  lineHeight: '100%',
  height: '60px',
  color: colors.whiteText,
  textWrap: 'nowrap',
  ...additionalStyles,
  [theme.breakpoints.down('md')]: {
    whiteSpace: 'pre-line',
    fontSize: '18px',
    padding: '20px 20px',
  },
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'pre-line',
    fontSize: '16px',
    padding: '20px 20px',
  },
  '&:hover': {
    backgroundColor: '#1f2e3e',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: 'none',
  },
}));

export const CTAButtonOutlined = styled(CTAButtonContained, {
  shouldForwardProp: (prop) => prop !== 'additionalStyles',
})(({ theme, additionalStyles }) => ({
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: 'rgba(73, 42, 24, 0.04)',
    boxShadow: 'none',
  },
  ...additionalStyles,
}));
